import GuaranteesScreen from "./screens/Guarantees";
import MainScreen from "./screens/Main";

const content = path => `/content-renderer/content/returnsandrefunds/${path}`;

export default {
  guaranteesAndTroubleshootingGuides: {
    title: "Guarantees & Troubleshooting",
    solution: MainScreen,
  },
  guarantees: {
    title: "Guarantees",
    solution: GuaranteesScreen,
  },
  electricals: {
    title: "Electricals, Technology & Lighting",
    options: [
      {
        buttonLabel: "Computing guarantees (Apple products)",
        nextPage: "electricalComputingApple",
      },
      {
        buttonLabel: "Computing guarantees (non-Apple products)",
        nextPage: "electricalComputingNonApple",
      },
      {
        buttonLabel: "Audio guarantees",
        nextPage: "electricalAudio",
      },
      {
        buttonLabel: "Large electrical appliances guarantees",
        nextPage: "electricalLarge",
      },
      {
        buttonLabel: "Small electrical appliances guarantees",
        nextPage: "electricalSmall",
      },
      {
        buttonLabel: "TV guarantees",
        nextPage: "electricalTv",
      },
      {
        buttonLabel: "Lighting guarantees",
        nextPage: "electricalLighting",
      },
      {
        buttonLabel: "Other electrical product guarantees",
        nextPage: "electricalOther",
      },
    ],
  },
  electricalComputingApple: {
    title: "Computing guarantees (Apple products)",
    esiContent: content("computing-guarantees-apple-products"),
  },
  electricalComputingNonApple: {
    title: "Computing guarantees (non-Apple products)",
    esiContent: content("computing-guarantees-non-apple-products"),
  },
  electricalAudio: {
    title: "Audio guarantees",
    esiContent: content("audio-guarantees"),
  },
  electricalLarge: {
    title: "Large electrical appliances guarantees",
    esiContent: content("large-electrical-appliance-guarantees-new"),
  },
  electricalSmall: {
    title: "Small electrical appliances guarantees",
    esiContent: content("small-electrical-appliance-guarantees-new"),
  },
  electricalTv: {
    title: "TV guarantees",
    esiContent: content("tv-guarantees-new"),
  },
  electricalLighting: {
    title: "Lighting guarantees",
    esiContent: content("lighting-guarantees"),
  },
  electricalOther: {
    title: "Other electrical product guarantees",
    esiContent: content("other-electrical-product-guarantees"),
  },
  indoorFurniture: {
    title: "Beds, Bedding, Sofas & Soft Furnishings",
    options: [
      {
        buttonLabel: "Sofas, Armchairs & Sofabed guarantees",
        nextPage: "indoorFurnitureSofas",
      },
      {
        buttonLabel: "Mattress & Divan guarantees",
        nextPage: "indoorFurnitureMattress",
      },
      {
        buttonLabel: "Filled Bedding guarantees",
        nextPage: "indoorFurnitureFilled",
      },
      {
        buttonLabel: "7-day curtains & blinds guarantees",
        nextPage: "indoorFurnitureCurtains",
      },
    ],
  },
  indoorFurnitureSofas: {
    title: "Sofas, Armchair, Sofa bed guarantees",
    esiContent: content("sofas-armchair-and-sofabed-guarantees"),
  },
  indoorFurnitureMattress: {
    title: "Mattress & Divan guarantees",
    esiContent: content("mattress-and-divan-guarantees"),
  },
  indoorFurnitureFilled: {
    title: "Filled Bedding guarantees",
    esiContent: content("filled-bedding-guarantees"),
  },
  indoorFurnitureCurtains: {
    title: "7-day curtains & blinds guarantees",
    esiContent: content("7day-curtains-and-blinds-guarantees"),
  },
  cookware: {
    title: "Cookware & Bathroom Fittings",
    options: [
      {
        buttonLabel: "Cookware guarantees",
        nextPage: "cookwareLifetime",
      },
      {
        buttonLabel: "Bathroom Fittings Lifetime guarantees",
        nextPage: "bathroomLifetime",
      },
    ],
  },
  cookwareLifetime: {
    title: "Cookware Guarantees",
    esiContent: content("cookware-lifetime-guarantee"),
  },
  bathroomLifetime: {
    title: "Bathroom Fittings Lifetime guarantees",
    esiContent: content("bathroom-fittings-lifetime-guarantee"),
  },
  prams: {
    title: "Pushchairs, Car Seats and Baby Electricals",
    options: [
      {
        buttonLabel: "Prams, Pushchairs & Car Seats guarantees",
        nextPage: "pramsGuarantees",
      },
      {
        buttonLabel: "Supplier contact for Nursery Travel Products",
        nextPage: "nurseryTravel",
      },
      {
        buttonLabel: "Baby Electricals guarantees",
        nextPage: "babyElectricalGuarantees",
      },
    ],
  },
  pramsGuarantees: {
    title: "Prams, Pushchairs & Car Seats guarantees",
    esiContent: content("prams-pushchairs-and-car-seat-guarantees"),
  },
  nurseryTravel: {
    title: "Supplier contact for Nursery Travel Products",
    esiContent: content("supplier-contact-for-nursery-travel-products"),
  },
  babyElectricalGuarantees: {
    title: "Baby Electricals guarantees",
    esiContent: content("baby-electrical-guarantees"),
  },
  outdoorFurniture: {
    title: "Outdoor Furniture guarantees",
    esiContent: content("outdoor-furniture-guarantees"),
  },
  luggage: {
    esiContent: content("luggage-guarantees"),
  },
};
